const BREAKPOINTS = {
	tablet: 728,
	desktop: 1025,
};

const LOCALE_MAP = {
	au: "en-AU",
	de: "de-DE",
	en: "en-US",
	es: "es-ES",
	fr: "fr-FR",
	it: "it-IT",
	uk: "en-GB",
};

function decodeHtmlEntities(value = "") {
	if (typeof document === "undefined") {
		return value;
	}

	const textarea = document.createElement("textarea");
	textarea.innerHTML = value;
	return textarea.value;
}

export function toPlainText(value = "") {
	return decodeHtmlEntities(value)
		.replace(/<[^>]*>/g, " ")
		.replace(/\s+/g, " ")
		.trim();
}

function trimText(value, maxLength = 170) {
	if (value.length <= maxLength) {
		return value;
	}

	return `${value.slice(0, maxLength).trimEnd()}...`;
}

function getPostTerms(post) {
	return (post?._embedded?.["wp:term"] || [])
		.flat()
		.filter(
			(term) => term && !["post_format", "post_tag"].includes(term.taxonomy),
		);
}

export function getPostCategory(post) {
	const terms = getPostTerms(post);
	const categoryTerm = terms.find((term) =>
		term.taxonomy?.includes("category"),
	);

	return categoryTerm?.name || terms[0]?.name || "";
}

export function formatPostDate(value, locale = "en") {
	if (!value) {
		return "";
	}

	const date = new Date(value);

	if (Number.isNaN(date.getTime())) {
		return "";
	}

	try {
		return date.toLocaleDateString(LOCALE_MAP[locale] || LOCALE_MAP.en, {
			day: "numeric",
			month: "long",
			year: "numeric",
		});
	} catch (error) {
		return date.toLocaleDateString(LOCALE_MAP.en, {
			day: "numeric",
			month: "long",
			year: "numeric",
		});
	}
}

export function normalizePost(
	post,
	{ buttonText = "Read more", locale = "en" } = {},
) {
	return {
		author: post?._embedded?.author?.[0]?.name || "",
		buttonText,
		category: getPostCategory(post),
		dateText: formatPostDate(post?.date, locale),
		excerpt: trimText(
			toPlainText(
				post?.excerpt?.rendered || post?.yoast_head_json?.og_description || "",
			),
			150,
		),
		id: post?.id,
		image: post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
		title: toPlainText(post?.title?.rendered || "Untitled post"),
		url: post?.link || "#",
	};
}

export function getPreviewCount(width = 0) {
	return width >= BREAKPOINTS.desktop ? 4 : 2;
}

export function getPreviewPosts(posts, activeIndex, previewCount) {
	if (posts.length <= 1) {
		return [];
	}

	const items = [];

	for (
		let offset = 1;
		offset < posts.length && items.length < previewCount;
		offset += 1
	) {
		const carouselIndex = (activeIndex + offset) % posts.length;
		items.push({ ...posts[carouselIndex], carouselIndex });
	}

	return items;
}

export function formatSlideCounter(activeIndex, total) {
	if (!total) {
		return "0/0";
	}

	return `${activeIndex + 1}/${total}`;
}
